import type { BaseAppError } from '@modules/core/errors';
import type {
  ISettingBookkeepingCreatePayload,
  ISettingBookkeepingCreateResponse,
} from '@modules/general-settings/submodules/bookkeeping/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS,
  SETTINGS_BOOKKEEPING_CREATE_QUERY_KEY,
  SETTINGS_BOOKKEEPING_CREATE_URL,
  SETTINGS_BOOKKEEPING_LIST_QUERY_KEY,
} from '@modules/general-settings/submodules/bookkeeping/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsBookkeepingCreateMutation(): ReturnType<
  typeof useContextMutation<ISettingBookkeepingCreateResponse, Error | BaseAppError, ISettingBookkeepingCreatePayload>
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingBookkeepingCreateResponse,
Error | BaseAppError,
ISettingBookkeepingCreatePayload
  >({
    mutationKey: [SETTINGS_BOOKKEEPING_CREATE_QUERY_KEY],
    mutationFn: (payload) => fetchPost<ISettingBookkeepingCreateResponse>(
      SETTINGS_BOOKKEEPING_CREATE_URL,
      payload,
      {
        permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_CREATE,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [SETTINGS_BOOKKEEPING_CREATE_QUERY_KEY, SETTINGS_BOOKKEEPING_LIST_QUERY_KEY] });
      await queryClient.refetchQueries({ queryKey: [SETTINGS_BOOKKEEPING_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
